var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from './BaseModel';
import OptionChoiceModel from './OptionChoiceModel';
import { find, forEach } from "lodash";
var OptionModel = /** @class */ (function (_super) {
    __extends(OptionModel, _super);
    function OptionModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.id = hydrated.id;
        _this.name = hydrated.name;
        _this.basePrice = hydrated.basePrice;
        _this.baseChoicePriceDelta = hydrated.baseChoicePriceDelta;
        _this.freeChoicesCount = hydrated.freeChoicesCount;
        _this.required = hydrated.required;
        _this.exclusive = hydrated.exclusive;
        _this.excludeFromMeals = hydrated.excludeFromMeals;
        _this.mobileInline = hydrated.mobileInline;
        _this.isDivisible = hydrated.isDivisible;
        _this.priority = hydrated.priority;
        _this.featureFlag = hydrated.featureFlag;
        _this.fontStyle = hydrated.fontStyle;
        _this.fontColor = hydrated.fontColor;
        _this.images = hydrated.images;
        _this.choices = hydrated.choices;
        _this.__mc = 'OptionModel';
        return _this;
    }
    OptionModel.prototype.hydrate = function (data) {
        var option = {};
        option['id'] = "" + data.option_id;
        option['name'] = data.name;
        option['basePrice'] = parseInt(data.base_price);
        option['baseChoicePriceDelta'] = +(data.base_choice_price_delta) || 0;
        option['freeChoicesCount'] = +data.free_choices_count || 0;
        option['required'] = data.required ? true : false;
        option['exclusive'] = data.exclusive ? true : false;
        option['excludeFromMeals'] = data.exclude_from_meals ? true : false;
        option['mobileInline'] = data.mobile_inline ? true : false;
        option['isDivisible'] = data.is_divisible ? true : false;
        option['priority'] = data.priority;
        option['featureFlag'] = data.feature_flag || null;
        option['fontStyle'] = data.font_style || null;
        option['fontColor'] = data.font_color || null;
        option['images'] = data.images || null;
        var optionChoices = [];
        data.choices.forEach(function (choiceData) {
            var choice = new OptionChoiceModel(choiceData, option['id']);
            if (option.required) {
                choice.required = true;
            }
            optionChoices.push(choice);
        });
        option['choices'] = optionChoices;
        return option;
    };
    OptionModel.prototype.hydrateFromStore = function (data) {
        var option = {};
        option = data;
        return option;
    };
    OptionModel.prototype.updateChoices = function (choicesOverwrite) {
        forEach(this.choices, function (choice) {
            forEach(choicesOverwrite, function (overwrite) {
                if (choice.id === overwrite.gcid) {
                    choice.priceDelta = overwrite.price_delta || overwrite.priceDelta;
                    choice.excluded = overwrite.excluded;
                }
            });
        });
    };
    OptionModel.prototype.getExistingChoice = function (apiChoice) {
        return find(this.choices, function (choice) {
            return choice.id === apiChoice.choice_id;
        });
    };
    return OptionModel;
}(BaseModel));
export default OptionModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/OptionModel.ts
// module id = Y7gR
// module chunks = 18